export const RESET = 'EXCMCORRESPONDENCE_LIST_RESET'
export const SET_ITEMS = 'EXCMCORRESPONDENCE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMCORRESPONDENCE_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMCORRESPONDENCE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMCORRESPONDENCE_LIST_TOGGLE_LOADING'
